export default "__VITE_ASSET__sgYcb8ku__"